import * as msal from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: '65667ef9-c12e-4a4a-89f0-2a35ec31bb1c',
    authority: 'https://login.microsoftonline.com/2046864f-68ea-497d-af34-a6629a6cd700',
    redirectUri: process.env.VUE_APP_ROOT,
    validateAuthority: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export default {
  namespaced: true,
  state: {
    loginResponse: null,
    loginRequest: {
      scopes: [ "api://d97b7344-7239-432b-84c9-2f8bf0f98731/FD.ACCESS"  ],
    },
  },
  mutations: {
    loginResponse (state, payload) {
      state.loginResponse = payload;
    },
  },
  actions: {
    async startSession ({ dispatch, state }) {

      if (state.loginResponse) {
        await dispatch('silentLogin');
      }

      if (!state.loginResponse) {
        await dispatch('popupLogin');
      }

      await dispatch('login');

    },

    async silentLogin ({ state, commit }) {

      const tokenRequest = {
        ...state.loginRequest,
        account: state.loginResponse.account,
      };

      try {
        const silentLogin = await this.msalInstance.acquireTokenSilent(tokenRequest);
        commit('loginResponse', silentLogin);
      } catch (err) {
        this.$error(err.response.data.message);
      }

    },

    async popupLogin ({ commit, state }) {
      try {
        const popupLogin = await msalInstance.loginPopup(state.loginRequest);
        commit('loginResponse', popupLogin);
      } catch (err) {
        this.$error(err.response.data.message);
      }
    },

    async login ({ dispatch, state }) {

      try {
        const msalAuth = await this.$axios({
          url: `/admin/authenticate`,
          method: 'post',
          data: {},
          headers: {
            'Authorization': `Bearer ${state.loginResponse.accessToken}`,
          },
        });
        dispatch('login/login', msalAuth.data, { root: true });
      } catch (err) {
        this.$error(err.response.data.message);
      }

    },
  },
};
